module.exports = __webpack_public_path__ + "img/kl.b24d83a4.png";